import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { ExternalForm } from '../ExternalForm'
import { getEloquaCss } from './helper'
import withCta from 'LiveBoard/components/shared/CallToAction/types/forms/withCta'
import snakeCase from 'lodash/snakeCase'

const SUBMIT_EVENT = 'submit'
const ROBOTO_FONT_HREF = 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Open+Sans:300,400,500,700'

const ELOQUA_FIELD_NAMES_MAPPING = {
  emailAddress: 'email',
  title: 'headline',
  busPhone: 'phone'
}

const EloquaFormContainer = (props) => {
  const [heightInterval, setHeightInterval] = useState(null)
  const formSubmissionRef = useRef(props.getCtaParams())

  const setHiddenFieldValue = (fieldName, value) => {
    formSubmissionRef.current[replaceFormFieldName(fieldName)] = value
  }

  const replaceFormFieldName = (field) => {
    const fieldName = ELOQUA_FIELD_NAMES_MAPPING[field] || field
    return snakeCase(fieldName)
  }

  const getSubmitData = (formElementIframe) => {
    const formFields = formElementIframe.current.contentWindow.document.querySelectorAll('.elq-item-input, .elq-item-select')
    for (const field of formFields) {
      formSubmissionRef.current[replaceFormFieldName(field.name)] = field.value
    }

    return formSubmissionRef.current
  }

  const submitEloquaForm = (formData) => {
    return props.onSubmit(
      formData,
      Object.keys(formData),
      props.config.form.success_message
    )
  }

  const validForm = (formElementIframe) => {
    return formElementIframe.current.contentWindow.document.querySelectorAll('.LV_invalid').length === 0
  }

  const handleSubmit = (formElementIframe) => {
    if (validForm(formElementIframe)) {
      const formData = getSubmitData(formElementIframe)
      setTimeout(() => submitEloquaForm(formData), 2000)
    }
  }

  const addSubmitListener = (formElementIframe) => {
    const formId = props.config.form.form_id
    const iframeDocument = formElementIframe.current.contentWindow.document
    setEloquaStyle(iframeDocument)
    setChangeHeightInterval(formElementIframe)
    dispatchFormLoadedEvent(iframeDocument)
    const form = iframeDocument.getElementById(`form${formId}`)
    form.addEventListener(SUBMIT_EVENT, (e) => handleSubmit(formElementIframe))
  }

  const removeSubmitListener = () => {
    clearInterval(heightInterval)
  }

  const setChangeHeightInterval = (formElementIframe) => {
    const interval = setInterval(function() {
      const iframeHeight = formElementIframe.current.contentWindow.document.body.scrollHeight
      if (formElementIframe.current.style.height !== iframeHeight) {
        formElementIframe.current.style.height = iframeHeight + 'px'
      }
    }, 200)
    setHeightInterval(interval)
  }

  const setEloquaStyle = (iframeDocument) => {
    const fontLink = iframeDocument.createElement('link')
    fontLink.href = ROBOTO_FONT_HREF
    fontLink.rel = 'stylesheet'
    iframeDocument.head.append(fontLink)

    const style = iframeDocument.createElement('style')
    style.textContent = getEloquaCss(props.themeColorHex)
    iframeDocument.head.append(style)
  }

  const dispatchFormLoadedEvent = (iframeDocument) => {
    const customEvent = new CustomEvent(
      'follozeFormLoaded',
      {
        detail: {
          setFieldValue: setHiddenFieldValue,
          formName: props.config.form.form_name,
          document: iframeDocument
        }
      }
    )
    window.dispatchEvent(customEvent)
  }

  return (
    <div className='eloqua-embedded-form'>
      <ExternalForm
        addSubmitListener={addSubmitListener}
        removeSubmitListener={removeSubmitListener}
        config={props.config}
        onDone={props.onDone} />
    </div>
  )
}

EloquaFormContainer.propTypes = {
  config: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  itemId: PropTypes.number,
  onDone: PropTypes.func,
  onSubmit: PropTypes.func,
  getCtaParams: PropTypes.func
}

export default withCta(EloquaFormContainer)
